export enum RedeemChannelType {
    Card = 1,
    Paypal = 2,
    CashApp = 11,
    ApmAch = 20,
    ApmMazooma = 21,
}